<template>
  <transition name="el-fade-in-linear">
  <div v-show="transitionshow">

      <el-form :inline="true" class="backborder1 demo-form-inline" size="small">
            <el-form-item style="width:15%">
	            <el-select v-model="query.brandid" clearable filterable  placeholder="按品牌" @change="query.ischange=true">
	            	<el-option label="不分品牌" value="0"></el-option>
	                <el-option v-for="(item,index) in brandlists" :label="item.showlable" :value="item.id" :key="index">
	                	<span style="float: left">{{item.name}}</span>
      				    <span style="float: right; color: #C0C4CC; font-size: 13px">{{item.py}}</span>
	                </el-option>
	            </el-select>
            </el-form-item>
            <el-form-item ref="query" :model="query">
            	<el-input placeholder="请输入关键字" v-model="query.key" clearable @keyup.enter.native="getList" @change="query.ischange=true"></el-input>
            </el-form-item>
            <el-form-item>
                <el-button :type="item.select ? 'primary' : ''" round v-for="(item,index) in datetypelists" :key="index" @click="selectdate(index,item.id)">{{item.name}}</el-button>
           	    <el-button type="primary" icon="el-icon-search" @click="getList">查询</el-button>
            </el-form-item>
            <el-form-item>
           	    <el-button type="success" icon="el-icon-download" @click="getexport">导出</el-button>
            </el-form-item>
      </el-form>       

      <div class="backborder2" style="margin-top:10px" v-loading="query.loading">
          <table class="clb-fulture">
              <tr>
                <th v-for="(item,index) in lists.title" :key="index" :align="index==0 ? 'left' : 'center' " style="border-bottom:1px solid #dddddd">{{item}}</th>
              </tr>
              <tr v-for="(item,index) in lists.data" :key="index">
                <td>
                  <span class="name">{{item.name}}</span>
                  <span class="spec">规格：{{item.spec}}，编号：{{item.number}}，品牌：{{item.brandname}}</span>
                </td>
                <td align="center" >{{item.inventory}}</td>
                <td align="center" v-if="item.time0 >=0">{{item.time0}}</td>
                <td align="center" v-if="item.time1 >=0">{{item.time1}}</td>
                <td align="center" v-if="item.time2 >=0">{{item.time2}}</td>
                <td align="center" v-if="item.time3 >=0">{{item.time3}}</td>
                <td align="center" v-if="item.time4 >=0">{{item.time4}}</td>
                <td align="center" v-if="item.time5 >=0">{{item.time5}}</td>
                <td align="center" v-if="item.time6 >=0">{{item.time6}}</td>
                <td align="center" v-if="item.time7 >=0">{{item.time7}}</td>
                <td align="center" v-if="item.time8 >=0">{{item.time8}}</td>
                <td align="center" v-if="item.time9 >=0">{{item.time9}}</td>
                <td align="center" v-if="item.time10 >=0">{{item.time10}}</td>
                <td align="center" v-if="item.time11 >=0">{{item.time11}}</td>
                <td align="center">{{item.saverage}}</td>
                <td align="center">{{item.fulture}}</td>
                <td align="center">{{item.salesdays}}</td>
              </tr>
          </table>
          <div class="block">
	        <!--分页begin-->
	          <el-pagination
	            @size-change="pageSizeChange"
	            @current-change="pageCurrentChange"
	            :current-page="query.p"
	            :page-sizes="[10, 20, 50]"
	            :page-size="query.rollpage"
	            layout="total, sizes, prev, pager, next, jumper"
	            :total="rows">
	          </el-pagination>
	          <!--分页end-->
	        </div>
      </div>    


  </div>
  </transition>
</template>

<script>

export default {
  props:['childdata'],
  data () {
    return {
      url:this.GLOBAL.domain+"Inventory/index",
      transitionshow:true,
      query:{
        act:'getsalefultrue',
        token:this.$cookies.get('token'),
        datetype:2,
        brandid:'',
        key:'',
        rollpage: 10, // 页大小
        p: 1,
        ischange:false,
        loading:false,
      },
      lists:[],
      rows:0,
      brandlists:[],
      datetypelists:[
        {id:1,name:'最近1个月销售数据参考',select:false},
        {id:2,name:'最近3个月销售数据参考',select:true},
        {id:3,name:'最近6个月销售数据参考',select:false},
        {id:4,name:'最近12个月销售数据参考',select:false}
      ],

      

    }
  },

  mounted(){
    this.getBrand();
    this.getList();
  },

  methods:{

      //获取品牌
      getBrand(){
          var resource = this.$resource(this.GLOBAL.domain+"Brand/index");
          resource.query({act:'lists',token:this.$cookies.get('token'),rollpage:1000}).then((res) => {
              if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
              }else{
                this.brandlists = JSON.parse(Base64.decode(res.data.Data));
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
          });
      },

      //选择查询时间范围
      selectdate(index,id) {
        this.datetypelists.forEach(function(t,i) {
            t.id!=id ? t.select=false : t.select=true;
        });
        if(this.query.datetype!=id) this.query.ischange=true;
        this.query.datetype=id;
      },


      //查询数据
      getList() {
          if(this.query.ischange) {
            this.query.p=1;
            this.query.rollpage=10;
          }

          this.query.loading=true;
          var resource = this.$resource(this.url);
          resource.save(this.query).then((res) => {
              if(res.data.Result>0){
                if(res.data.Result=='70001') this.$router.push('/login')
                this.$message.error(res.data.Message);
                this.query.loading=false;
              }else{
                this.lists = JSON.parse(Base64.decode(res.data.Data));
                this.rows=parseInt(res.data.count);
                this.query.loading=false;
                if(this.query.ischange) this.query.ischange=false;
              }
          }).catch((res) => {
              this.$message.error(this.GLOBAL.errortext);
              this.query.loading=false;
          });
      },
      pageSizeChange(val) {
        this.query.rollpage = val;
        this.getList();
      },
      pageCurrentChange(val) {
          this.query.p = val;
          this.getList();
      },


      //导出商品信息
      getexport() {
          var url=this.GLOBAL.exportUrl+'Inventory/index/act/exportsalefutrue/token/'+this.$cookies.get('token');
          if(this.query.datetype > 0) url+="/datetype/"+this.query.datetype;
          if(this.query.brandid > 0) url+="/brandid/"+this.query.brandid;
          if(this.query.key!='') url+="/key/"+this.query.key;
          location.href=url;
      },


  }

}
</script>
<style>
.backborder1 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:1% 1% 0 1%}
.backborder2 {background:#fff;border-radius:15px;border:1px solid #ddd;padding:0 1% 3% 1%}
.clb-fulture {width:100%;font-size:13px;margin-top:20px}
.clb-fulture .name {float:left;width:100%}
.clb-fulture .spec {float:left;color:#999999}
.clb-fulture th,.clb-fulture td {font-weight:normal;line-height:23px;font-size:13px;padding:15px 15px}
.clb-fulture td {border-bottom:1px solid #dddddd}
</style>


// WEBPACK FOOTER //
// src/components/inventory/showsalefulture.vue